import React from "react";
import Icon from "@ant-design/icons";


const StaffCheckOutSvg = () => (
    <svg fill="currentColor" width="1em" height="1em" viewBox="0 0 48 48">
        <path d="M27.84,34.91c.25.25.57.38.89.38s.63-.12.87-.36l10.03-9.82c.24-.23.38-.56.38-.89s-.14-.66-.38-.89l-10.03-9.82c-.49-.48-1.28-.47-1.77.02-.48.49-.47,1.28.02,1.77l7.84,7.68H15.72c-.69,0-1.25.56-1.25,1.25s.56,1.25,1.25,1.25h19.99l-7.84,7.68c-.49.48-.5,1.27-.02,1.77Z" />
        <path d="M40.66,14.92v-3.22c0-3.96-3.23-7.19-7.19-7.19H15.15c-3.96,0-7.19,3.23-7.19,7.19v25.02c0,3.96,3.23,7.19,7.19,7.19h18.31c3.96,0,7.19-3.23,7.19-7.19v-3.12c0-.69-.56-1.25-1.25-1.25s-1.25.56-1.25,1.25v3.12c0,2.59-2.1,4.69-4.69,4.69H15.15c-2.59,0-4.69-2.1-4.69-4.69V11.7c0-2.59,2.1-4.69,4.69-4.69h18.31c2.59,0,4.69,2.1,4.69,4.69v3.22c0,.69.56,1.25,1.25,1.25s1.25-.56,1.25-1.25Z" />
    </svg>
);

const StaffCheckOutIcon = (props) => <Icon { ...props } component={ StaffCheckOutSvg } />;

export default StaffCheckOutIcon;
